module.exports = __webpack_public_path__ + "img/cartoonHead0-1.4dd0e912.png";